import { initCustomerNameInlineEdit } from "./customer_success/edit_inline/customers_name_inline_edit";
import { initCustomersRenewInlineEdit } from "./customer_success/edit_inline/customers_renew_inline_edit";
import { initCustomersNumberInlineEdit } from "./customer_success/edit_inline/customers_number_inline_edit";
import { initCustomersSelectInlineEdit } from "./customer_success/edit_inline/customers_select_inline_edit";
import { initCustomersTagsInlineEdit } from "./customer_success/edit_inline/customers_tags_inline_edit";
import { getTagColor } from "./cs_dashboard";

function initCustomersStatusInlineEdit() {
  initCustomersSelectInlineEdit({
    selector: ".customers-table .company-status",
    eventNamespace: "click.cs-inline-edit-status",
    optionsAttr: "data-status-options",
    payloadField: "status",
    parseErrorMessage: "Error parsing status options:",
  });
}

function initCustomersCsInlineEdit() {
  initCustomersSelectInlineEdit({
    selector: ".customers-table .company-cs",
    eventNamespace: "click.cs-inline-edit-cs",
    optionsAttr: "data-customer-success-options",
    payloadField: "customer_success",
    parseErrorMessage: "Error parsing customer success options:",
  });
}

function initCustomersAmInlineEdit() {
  initCustomersSelectInlineEdit({
    selector: ".customers-table .company-am",
    eventNamespace: "click.cs-inline-edit-am",
    optionsAttr: "data-account-manager-options",
    payloadField: "account_manager",
    parseErrorMessage: "Error parsing account manager options:",
  });
}

function initCustomersOtpInlineEdit() {
  initCustomersSelectInlineEdit({
    selector: ".customers-table .company-opt-in",
    eventNamespace: "click.cs-inline-edit-otp-in",
    optionsAttr: "data-opt-in-options",
    payloadField: "opt_in",
    parseErrorMessage: "Error parsing OTP options:",
  });
}

function initCustomersCsmScoreInlineEdit() {
  initCustomersSelectInlineEdit({
    selector: ".customers-table .company-csm-score",
    eventNamespace: "click.cs-inline-edit-csm-score",
    optionsAttr: "data-csm-score-options",
    payloadField: "csm_score",
    parseErrorMessage: "Error parsing CSM Score options:",
  });
}

function initCustomersMacroScoreInlineEdit() {
  initCustomersSelectInlineEdit({
    selector: ".customers-table .company-macro-score",
    eventNamespace: "click.cs-inline-edit-macro-score",
    optionsAttr: "data-macro-score-options",
    payloadField: "macro_score",
    parseErrorMessage: "Error parsing Macro Score options:",
  });
}

function initCustomersCountryInlineEdit() {
  initCustomersSelectInlineEdit({
    selector: ".customers-table .company-country",
    eventNamespace: "click.cs-inline-edit-country",
    optionsAttr: "data-country-options",
    payloadField: "country",
    parseErrorMessage: "Error parsing country options:",
  });
}

function initCustomersChurnRiskInlineEdit() {
  initCustomersSelectInlineEdit({
    selector: ".customers-table .company-churn-risk",
    eventNamespace: "click.cs-inline-edit-churn-risk",
    optionsAttr: "data-churn-risk-options",
    payloadField: "churn_risk",
    parseErrorMessage: "Error parsing churn risk options:",
  });
}

function initCustomersMrrInlineEdit() {
  initCustomersNumberInlineEdit({
    selector: ".customers-table .company-mrr",
    eventNamespace: "click.cs-inline-edit-mrr",
    payloadField: "mrr",
    parseErrorMessage: "Error parsing MRR value:",
  });
}

export function initToolTableInteractions() {
  // Field name
  initCustomerNameInlineEdit();

  // Field status
  initCustomersStatusInlineEdit();

  // Field CS
  initCustomersCsInlineEdit();

  // Field AM
  initCustomersAmInlineEdit();

  // Field OTP
  initCustomersOtpInlineEdit();

  // Field CSM Score
  initCustomersCsmScoreInlineEdit();

  // Field Macro Score
  initCustomersMacroScoreInlineEdit();

  // Field Renews
  initCustomersRenewInlineEdit();

  // Field Country
  initCustomersCountryInlineEdit();

  // Field Churn Risk
  initCustomersChurnRiskInlineEdit();

  // Field MRR
  initCustomersMrrInlineEdit();

  // Field Tags
  initCustomersTagsInlineEdit();
}

function scoreBadgeColor(value: string): string {
  const normalized = value.toLowerCase();
  if (["poor", "fair", "good"].includes(normalized)) {
    return normalized;
  }

  return "not-available";
}

function renderScoreBadge(cell: HTMLElement, value: string) {
  const span = document.createElement("span");
  const scoreValue = value || "-";

  span.className = `score ${scoreBadgeColor(scoreValue)}`;
  span.textContent = scoreValue;

  cell.textContent = "";
  cell.appendChild(span);
}

function renderBooleanBadge(cell: HTMLElement, isTrue: boolean) {
  const value = isTrue ? "yes" : "no";
  const span = document.createElement("span");

  span.className = `boolean-value ${value}`;
  span.textContent = value;

  cell.textContent = "";
  cell.appendChild(span);
}

function renderOptInBadge(cell: HTMLElement, value: string) {
  const color = value || "not-available";
  const label = value || "-";
  const span = document.createElement("span");

  span.className = `boolean-value ${color}`;
  span.textContent = label;

  cell.textContent = "";
  cell.appendChild(span);
}

function renderTextValue(cell: HTMLElement, value: string, wrapInDiv: boolean) {
  cell.textContent = "";

  if (wrapInDiv) {
    const div = document.createElement("div");
    div.textContent = value;
    cell.appendChild(div);
    return;
  }

  cell.textContent = value;
}

function formatNumberWithDelimiter(value: string): string {
  if (value == "") return ""
  const numberValue = Number(value);
  if (isNaN(numberValue)) {
    return value;
  }

  return numberValue.toLocaleString("en-US");
}

function formatDateForDisplay(value: string): string {
  if (!value) {
    return "";
  }

  const date = new Date(`${value}T00:00:00`);
  if (isNaN(date.getTime())) {
    return value;
  }

  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
}

function openAllTagsModal(companyName: string, tags: string[]) {
  const modal = $("#all-tags-modal");
  if (modal.length === 0) {
    return;
  }

  const modalCompanyName = modal.find("#all-tags-modal-label");
  const modalTagsContainer = modal.find("#modal-tags-container");

  modalCompanyName.text(companyName);
  modalTagsContainer.empty();

  tags.forEach((tag) => {
    const tagElement = $("<span>", {
      class: `score ${getTagColor(tag)} mr-2 mb-2`,
      text: tag,
    });
    modalTagsContainer.append(tagElement);
  });

  modal.modal("show");
}

function renderNameValue(nameElement: HTMLElement, value: string) {
  const nameCell = nameElement.closest('td[data-column="name"]');
  const expandIcon = nameElement.nextElementSibling as HTMLElement | null;

  if (nameCell) {
    nameCell.setAttribute("data-sort-value", value);
  }

  nameElement.setAttribute("data-full-name", value);
  nameElement.textContent = value;

  if (expandIcon) {
    expandIcon.setAttribute("data-content", value);
    const shouldShowExpandIcon =
      nameElement.scrollWidth > nameElement.clientWidth;
    expandIcon.style.display = shouldShowExpandIcon ? "inline-block" : "none";
  }
}

function renderTagsValue(cell: HTMLElement, tags: string[]) {
  const normalizedTags = tags.filter((tag) => typeof tag === "string" && tag != "");
  const humanizedTags = normalizedTags.map((tag) => humanizeOptionLabel(tag));
  const displayedTags = humanizedTags.slice(0, 1);
  const remainingCount = humanizedTags.length - displayedTags.length;

  cell.setAttribute("data-tags-value", JSON.stringify(normalizedTags));
  cell.textContent = "";

  displayedTags.forEach((tag) => {
    const badge = document.createElement("span");
    badge.className = `score ${getTagColor(tag)}`;
    badge.textContent = tag;
    cell.appendChild(badge);
  });

  if (remainingCount > 0) {
    const row = cell.closest(".customer-row");
    let companyName = "";

    if (row) {
      const nameElement = row.querySelector(
        ".company-name",
      ) as HTMLElement | null;
      if (nameElement) {
        companyName =
          nameElement.getAttribute("data-full-name") ||
          (nameElement.textContent || "").trim();
      }
    }

    const moreTags = document.createElement("span");
    moreTags.className = "score secondary additional-tags-trigger";
    moreTags.textContent = `+${remainingCount}`;
    moreTags.title = "Click to view all tags";
    moreTags.style.cursor = "pointer";
    moreTags.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      openAllTagsModal(companyName, humanizedTags);
    });
    moreTags.setAttribute("data-all-tags", JSON.stringify(humanizedTags));
    moreTags.setAttribute("data-company-name", companyName);
    
    cell.appendChild(moreTags);
  }
}

function renderCsDatumField(
  cell: HTMLElement,
  payloadField: string,
  newValue: any,
) {
  const valueAsString =
    newValue === null || newValue === undefined ? "" : String(newValue);

  if (payloadField === "status") {
    const displayValue = humanizeOptionLabel(valueAsString);
    cell.setAttribute("data-sort-value", displayValue);
    renderTextValue(cell, displayValue, true);
    return;
  }

  if (payloadField === "csm_score" || payloadField === "macro_score") {
    cell.setAttribute("data-sort-value", valueAsString);
    renderScoreBadge(cell, valueAsString);
    return;
  }

  if (payloadField === "opt_in") {
    cell.setAttribute("data-sort-value", valueAsString);
    renderOptInBadge(cell, valueAsString);
    return;
  }

  if (payloadField === "churn_risk") {
    const normalized = valueAsString.toLowerCase();
    const isTrue =
      newValue === true ||
      newValue === 1 ||
      valueAsString === "1" ||
      normalized === "yes" ||
      normalized === "true";
    cell.setAttribute("data-sort-value", isTrue ? "1" : "0");
    renderBooleanBadge(cell, isTrue);
    return;
  }

  if (payloadField === "mrr") {
    const normalizedValue = Number(valueAsString);
    const sortValue = isNaN(normalizedValue)
      ? valueAsString
      : normalizedValue.toString();
    cell.setAttribute("data-sort-value", sortValue);
    cell.textContent = formatNumberWithDelimiter(valueAsString);
    return;
  }

  if (payloadField === "renews") {
    cell.setAttribute("data-sort-value", valueAsString);
    cell.textContent = formatDateForDisplay(valueAsString);
    return;
  }

  if (payloadField === "tags") {
    if (Array.isArray(newValue)) {
      renderTagsValue(cell, newValue as string[]);
    }
    return;
  }

  const displayValue = humanizeOptionLabel(valueAsString);
  cell.setAttribute("data-sort-value", displayValue);
  renderTextValue(cell, displayValue, false);
}

function applyInlineUpdate(params: Record<string, any>, element: HTMLElement) {
  if (
    typeof params.name === "string" &&
    element.classList.contains("company-name")
  ) {
    renderNameValue(element, params.name);
    return;
  }

  const csDatumAttributes = params.cs_datum_attributes;
  if (!csDatumAttributes || typeof csDatumAttributes !== "object") {
    return;
  }

  const payloadFields = [
    "status",
    "customer_success",
    "account_manager",
    "opt_in",
    "csm_score",
    "macro_score",
    "country",
    "churn_risk",
    "mrr",
    "renews",
    "tags",
  ];

  for (let i = 0; i < payloadFields.length; i += 1) {
    const payloadField = payloadFields[i];
    if (Object.prototype.hasOwnProperty.call(csDatumAttributes, payloadField)) {
      renderCsDatumField(
        element,
        payloadField,
        csDatumAttributes[payloadField],
      );
      return;
    }
  }
}

export function patchCompany(
  id: string,
  params: Record<string, any>,
  element: HTMLElement,
  originalHTML: string,
) {
  $.ajax({
    url: `/customer_success/update?id=${id}`,
    method: "PATCH",
    data: { user_company: params },
    dataType: "json",
    success: function (data) {
      element.classList.remove("inline-edit-saving");

      if (data.success) {
        applyInlineUpdate(params, element);
      } else {
        element.innerHTML = originalHTML;
        alert("Update failed: " + (data.errors || []).join(", "));
      }
    },
    error: function () {
      element.classList.remove("inline-edit-saving");
      element.innerHTML = originalHTML;
      alert("Network error, please try again.");
    },
  });
}

export function humanizeOptionLabel(value: string): string {
  return value.replace(/_/g, " ").replace(/^./, (char) => char.toUpperCase());
}

export function parseOptions(optionsRaw: string, errorMessage: string) {
  try {
    const parsed = JSON.parse(optionsRaw);
    if (Array.isArray(parsed)) {
      return parsed.filter((option) => typeof option === "string") as string[];
    }
  } catch (error) {
    console.error(errorMessage, error);
  }

  return [];
}
